export default {
  namespaced: true,
  state: {
    placeholder: `e.g. \nhttps://demo.sirv.com/example.spin` +
                 `\nhttps://demo.sirv.com/example-image.jpg` +
                  `\nhttps://demo.sirv.com/another-example-image.jpg`,
    defaultUrls: ''
  },
  mutations: {
    changeDefaultUrls(state, payload) {
      state.defaultUrls = payload
    }
  },
  actions: {
    changeDefaultUrls({ commit }, defaultUrls) {
      commit('changeDefaultUrls', defaultUrls)
    }
  },
  getters: {
    defaultUrls: state => state.defaultUrls,
    placeholder: state => state.placeholder
  }
}
